import { track } from '../../../Utility/Tracking/Track';
import { IGameState } from '../../Game/IGameState';
import { LevelType } from '../../Level/ILevelState';
import { IPlayerState } from '../IPlayerState';
import { getCurrentLevelNumber, setLevels } from '../PlayerLevelHelper';
import { createMissions } from '../PlayerMissionHelper';
import { updateTimers } from '../PlayerTimerHelper';
import { setMusicVolume } from './SetMusicVolume';
import { setSoundVolume } from './SetSoundVolume';

export function setPlayerState(
    state: IGameState,
    newPlayerState: IPlayerState
): IGameState {
    // Do not update levels directly -- use helper method.
    const sagaLevels = newPlayerState.levels.saga;
    const challengeLevels = newPlayerState.levels.challenge;
    delete newPlayerState.levels;
    state = {
        ...state,
        playerState: {
            ...newPlayerState,
        },
    };

    // Update levels via helper method.
    state = setLevels(state, LevelType.SAGA, sagaLevels);
    state = setLevels(state, LevelType.CHALLENGE, challengeLevels);

    // Coerce world value.
    state.playerState.world = Math.max(1, state.playerState.world);

    state.playerState = updateTimers(state.playerState);

    state.playerState = createMissions(state.playerState);

    state = setMusicVolume(state, state.playerState.volumeMusic);
    state = setSoundVolume(state, state.playerState.volumeSFX);

    track('changerBooster', state.playerState.inventory.boosterShuffle);
    track('removeOneBooster', state.playerState.inventory.boosterBullsEye);
    track('massRemoveBooster', state.playerState.inventory.boosterTNT);
    track('jokerBooster', state.playerState.inventory.boosterJoker);
    track('coins', state.playerState.coins);
    track('keysKeyHunt', state.playerState.keys);

    track('highestLevel', getCurrentLevelNumber(state));

    return state;
}
